var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"topico-texto mt-4 mb-5",domProps:{"innerHTML":_vm._s(_vm.texto)}})
}
var staticRenderFns = []

export { render, staticRenderFns }